//----------------------------------------------------
// src/pages/TestPDF.jsx
// Logboek24 – PDF-download testpagina
//----------------------------------------------------
import React from "react";
import DownloadPDFButton from "../components/DownloadPDFButton";

export default function TestPDF() {
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">📄 Test PDF Download</h1>

      <p className="text-gray-600 mb-6">
        Deze pagina test de verbinding met de backend PDF-generator.
        Klik op de knop hieronder om een PDF te downloaden.
      </p>

      {/* ✅ Gebruik een bestaand logboek ID uit je database */}
      <DownloadPDFButton entryId="68b2d8dcd994a39d6a55fca6" />
    </div>
  );
}
